import { render, staticRenderFns } from "./exchangeConfirmDlg.vue?vue&type=template&id=1a749bc2&scoped=true"
import script from "./exchangeConfirmDlg.vue?vue&type=script&lang=js"
export * from "./exchangeConfirmDlg.vue?vue&type=script&lang=js"
import style0 from "./exchangeConfirmDlg.vue?vue&type=style&index=0&id=1a749bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a749bc2",
  null
  
)

export default component.exports